"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var AtlasRate_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtlasRate = exports.ATLAS_RATE_ACCOUNT_MIN_DATA_SIZE = void 0;
const web3_js_1 = require("@solana/web3.js");
const data_source_1 = require("@staratlas/data-source");
exports.ATLAS_RATE_ACCOUNT_MIN_DATA_SIZE = 8 + // discriminator
    8; // atlas_rate
let AtlasRate = AtlasRate_1 = class AtlasRate {
    constructor(_data, _key) {
        this._data = _data;
        this._key = _key;
    }
    get data() {
        return this._data;
    }
    get key() {
        return this._key;
    }
    /**
     * Find the AtlasRate account address
     * @param program - Marketplace program
     * @returns PDA for Atlas Rate Account
     */
    static findAddress(program) {
        return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from('atlas_rate')], program.programId);
    }
    static decodeData(account, program) {
        return (0, data_source_1.decodeAccount)(account, program, AtlasRate_1);
    }
};
AtlasRate.ACCOUNT_NAME = 'atlasRateAccount';
AtlasRate.MIN_DATA_SIZE = exports.ATLAS_RATE_ACCOUNT_MIN_DATA_SIZE;
AtlasRate = AtlasRate_1 = __decorate([
    (0, data_source_1.staticImplements)(),
    __metadata("design:paramtypes", [Object, web3_js_1.PublicKey])
], AtlasRate);
exports.AtlasRate = AtlasRate;
//# sourceMappingURL=atlasRateAccount.js.map